import { render, staticRenderFns } from "./newdatawalluser.vue?vue&type=template&id=26a764a0&scoped=true"
import script from "./newdatawalluser.vue?vue&type=script&lang=js"
export * from "./newdatawalluser.vue?vue&type=script&lang=js"
import style0 from "./newdatawalluser.vue?vue&type=style&index=0&id=26a764a0&prod&lang=css"
import style1 from "./newdatawalluser.vue?vue&type=style&index=1&id=26a764a0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a764a0",
  null
  
)

export default component.exports